export interface UserInfo {
  tenantId: string;
  icAgentId: string;
  icBUId: string;
  userName: string;
  icClusterId: string;
  userId?: string;
  firstName: string;
  lastName: string;
}
